import { Component, Prop, Vue } from "vue-property-decorator";
import { STYLE_CLASSES } from "./../../../../shared/constants/StyleConstants";
import { ROLE_CONSTANTS } from "@/modules/Roles/constants/RoleConstants";
import { View } from "./../../models/View";
import ViewButton from "@/shared/components/ViewButton/ViewButton.vue";

@Component({
  name: "LandingCard",
  components: {
    ViewButton
  }
})
export default class LandingCard extends Vue {
  @Prop() viewsPrincipal!: View[];
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD_2;
  ROLE_CONST = ROLE_CONSTANTS.LANDING_CARD;
  card2Class = STYLE_CLASSES.CARD_PADING;

  get viewPrincipalSelect(): View[] {
    return this.viewsPrincipal
      ? this.viewsPrincipal.filter(view => view.actived)
      : [];
  }
}
